((w) => {
    "use strict";

    const assetId = '~/theme/v1/Views/Custom/Document/ViewDocumentTemplatedFeedbackForm.min.js';

    if (!((w).umwAssets?.[assetId])) {
        console.error(`No context found for ${assetId}`);
        return;
    }

    for (const ctx of (w).umwAssets[assetId]) {
        const docTeaaser = document.querySelector('#' + ctx.mainPanelId + ' .doc__teaser') as HTMLElement;
        if(!docTeaaser) {
            console.error(`No document teaser found in document item container`);
            continue;
        }
        const feedbackControl = document.querySelector('.js-feedback-control') as HTMLElement; // page builder class for wrapper of uc129 Feedback control.
        if (!feedbackControl) {
            console.error(`No feedback control with class "js-feedback-control" found in document control`);
            continue;
        }
        const customField = document.querySelector('.js-main-custom-field[data-label="btnFeedbackForm"]') as HTMLInputElement;
        if (!customField || customField?.value.trim() === '') {
            console.error(`No custom field with label "btnFeedbackForm" found in document control`);
            continue;
        }
    
        const button = w.jQuery('<button type="button" class="btn btn-primary button-modal-form-btn mb-3">' + customField.value + '</button>').on('click', function () {
            w.jQuery.fancybox.open({
                parentEl: "form:first",
                src: feedbackControl,
                type: 'inline'
            });
        });
        
        docTeaaser?.insertAdjacentElement('afterend', button[0]);
    }
})(window as any);